import { useModalState } from '@brenger/react';
import * as React from 'react';
import { Button, Dialog, Heading, Modal } from '../../../brenger-shared-ui';
import { useTypedSelector } from '../../../hooks';
import { getQuote } from '../ducks';
import { Translate } from 'react-localize-redux-dep-updated';
import { translate } from '../../../utils/localization';
import { BlockedReasonsSplittedList, getSplittedBlockedReasons } from './BlockedReasons';

export const BlockedTrModal: React.FC = () => {
  const modal = useModalState();
  const blocked = useTypedSelector(getQuote)?.blocked;

  React.useEffect(() => {
    if (blocked?.result) modal.open();
  }, [JSON.stringify(blocked)]);

  const { itemSpecificReasons } = getSplittedBlockedReasons(blocked?.reasons || []);

  return (
    <Dialog isActive={modal.isOpen}>
      <Modal onClick={modal.close} style={'blue'} open={modal.isOpen}>
        <Heading size={3}>{<Translate id="is_blocked.modal.header" />}</Heading>
        <BlockedReasonsSplittedList reasons={blocked?.reasons || []} />
        {itemSpecificReasons.length > 0 && (
          <div
            className="pt-[1em]"
            // eslint-disable-next-line @typescript-eslint/naming-convention
            dangerouslySetInnerHTML={{ __html: translate('is_blocked.modal.item_specific_hint') }}
          />
        )}
        <div className={'pt-[1em]'}>
          <Button fullWidth={true} buttonStyle={'secondary'} onClick={modal.close}>
            <Translate id="is_blocked.modal.button" />
          </Button>
        </div>
      </Modal>
    </Dialog>
  );
};
